import React, { Suspense, lazy, useEffect, useMemo } from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { useAuth } from "Auth"
import { Loading } from "./Loading"
import { Modal } from 'Modals/Modal'
import { useAppContext } from './AppContext';
import { Alert, Snackbar } from '@mui/material';
import { useSnackbar } from 'Components/Snackbar';
import { ImageModal } from 'Modals/ImageModal';
import { UpdateNotificationContainer } from 'Components/UpdateNotificationContainer';
import { InstallContainer } from 'Components/InstallContainer';
import Notifications from 'Components/Notifications';
const Authenticated = lazy(() => import("./Authenticated").then(module => ({ default: module.Authenticated })))
const UnAuthenticated = lazy(() => import("./UnAuthenticated").then(module => ({ default: module.UnAuthenticated })))

function Copyright({ className, textColor }) {
  return (
    <div className={className}>
      <Typography variant="body2" color={textColor} align="center" style={{ paddingTop: 50 }}>
        {'Copyright © '}
        <Link color="inherit" href="https://ateasesolutions.com" style={{ textDecoration: 'none' }}>
          AteaseKart - Powered by SK Software & Technologies
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
      <Typography variant="overline" component="p" color={textColor} align="center">
        Version: {global.appVersion}
      </Typography>
    </div>
  );
}

const App = () => {
  const { isAuthenticated, isLoading } = useAuth()
  const { key, isLoading: isGeneralLoading } = useAppContext()
  const { snackbar, closeSnackbar, autoHideDuration } = useSnackbar()
  const backgroundColorClass = useMemo(() => isAuthenticated ? 'bg-white' : 'bg-primary-blue', [isAuthenticated])
  const textColor = useMemo(() => isAuthenticated ? '' : 'primary', [isAuthenticated])

  useEffect(() => {
    document.body.classList.add(backgroundColorClass)
  }, [backgroundColorClass])

  return (
    <Container maxWidth={false} disableGutters key={key}>
      <UpdateNotificationContainer title="Get the latest version of AteaseKart" />
      <InstallContainer title="Install AteaseKart" />
      <Box sx={{ pb: 4, minHeight: '80vh' }} className={`${backgroundColorClass}`}>
        {isLoading ? <Loading /> : (
          <Suspense fallback={<Loading />}>{isAuthenticated ? <Authenticated /> : <UnAuthenticated />}</Suspense>
        )}
      </Box>
      <Copyright className={`${backgroundColorClass} print:hidden`} textColor={textColor} />
      <Modal />
      <ImageModal />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={autoHideDuration}
        onClose={closeSnackbar}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        sx={{ zIndex: 3000 }}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Notifications />
      {isGeneralLoading ? <Loading /> : null}
    </Container>
  )
}

export { App }
